module.exports = __webpack_public_path__ + "static/img/jiang1.e7ef8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiang1.png
// module id = cAY0
// module chunks = 1